import { Material, Mesh, PlaneBufferGeometry, Vector2, Vector4 } from 'three';

import { SphereItemType } from 'shared/interfaces/planogram';
import type { BaseObjectUserData } from 'shared/object3d/interfaces';

import BaseObject3D from 'shared/object3d/BaseObject3D';
import LodMaterial from '../lod/LodMaterial';
import { ImageObjectConfig } from '../interfaces/object_config';

interface ImageUserData extends BaseObjectUserData {
  mesh?: Mesh<PlaneBufferGeometry, Material>;
}

const geometry = new PlaneBufferGeometry(1, 1);

export default class ImageObject3D extends BaseObject3D<ImageUserData> {
  itemType = SphereItemType.Image;

  readonly mesh: Mesh<PlaneBufferGeometry, Material>;

  constructor() {
    super();

    this.itemType = SphereItemType.Image;
    this.mesh = new Mesh(geometry);
    this.add(this.mesh);
    this.userData.mesh = this.mesh;
  }

  configure(imageConfig: ImageObjectConfig, material: LodMaterial) {
    this.mesh.material = material;

    const { cropOffset, cropRatio, cornerRadius } = imageConfig;
    material.setItemUniforms({
      cropOffset: { value: new Vector2(...(cropOffset ?? [0, 0])) },
      cropRatio: { value: new Vector2(...(cropRatio ?? [1, 1])) },
      cornerRadius: { value: new Vector4(...(cornerRadius ?? [0, 0, 0, 0])) },
    });
  }
}
